<template>
  <div id="bounties">
    <info-box v-bind:description="description"></info-box>
    <header-title v-bind:title_img_src="title_img" />
    <nav-bar></nav-bar>
    <span v-if="notification">{{notification}}</span> 
    <ul>
      <li class="shop-item" v-for="lootItemId in lootShopLootItemIds" :key="lootItemId">
        <table style="width:100%;">
          <tr style="height:200px;"><td> 
          <!-- <tr><td>  -->
            <img class="shop-image" v-if="lootShopLootItems[lootItemId].image_url" :src="lootItemImageUrl(lootShopLootItems[lootItemId])"/>
          </td></tr>
          <tr><td> {{lootShopLootItems[lootItemId].name}} </td></tr>
          <tr v-if="lootShopLootItems[lootItemId].rarity"><td :class="`rarity-${lootShopLootItems[lootItemId].rarity}`"> {{lootShopLootItems[lootItemId].rarity.toUpperCase()}} </td></tr>
          <tr><td style="font-size:12px;"> {{categoryTextFor(lootShopLootItems[lootItemId])}} </td></tr>
          <tr><td> {{lootShopLootItems[lootItemId].description}} </td></tr>
          <tr><td> Owned: {{ownedLootItemsByLootItemId[lootItemId] ? ownedLootItemsByLootItemId[lootItemId].quantity : 0}} </td></tr>
          <tr><td> Max Ownable: {{lootShopLootItems[lootItemId].max_allowed > 0 ? lootShopLootItems[lootItemId].max_allowed : 'Unlimited'}} </td></tr>
          <tr><td><span class="price-content">{{formatCurrency(lootShopLootItems[lootItemId].price)}} <img class="currency-icon" :src="currencyIcon(lootShopLootItems[lootItemId].price_currency_type)"/></span></td></tr>
          <tr><td><span class="copyright" v-if="requiresAttribution" v-html="attributionText(lootShopLootItems[lootItemId])"></span></td></tr>
          <tr v-if="allowedToBuy(lootShopLootItems[lootItemId]).allowed"><td><button class="btn-enabled" @click="buy(lootShopLootItems[lootItemId])">BUY</button> </td></tr>
          <tr v-else style="height: 51px;"><td> {{allowedToBuy(lootShopLootItems[lootItemId]).reason}} </td></tr>
        </table>
      </li>
    </ul>
    <div style="font-size:12px">All items VIRTUAL. You are not buying physical items!</div>
    <span class="copyright">All product names, logos, and brands are property of their respective owners. All company, product and service names used in this website are for identification purposes only. Use of these names, logos, and brands does not imply endorsement.</span>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import Vue from 'vue'
import BigNumber from 'BigNumber.js'
import axios from 'axios'

export default {
  name: 'loot-shop',
  components: {
  },
  async mounted () {
    await this.refreshLootItems()
    if (!this.myOwnedLootItemIds) { return }
    this.myOwnedLootItemIds.forEach(oliid => {
      Vue.set(this.ownedLootItemsByLootItemId, this.ownedLootItems[oliid].loot_item_id, this.ownedLootItems[oliid])
    })
  },
  data () {
    return {
      title_img: 'swiftorland-title.svg',
      description: {
        title: 'Loot Shop',
        text: `Spend SwiftBUCKS and SwiftGOLD on awesome loot!`
      },
      ownedLootItemsByLootItemId: {},
      waitingForPurchase: false,
      notification: undefined,
      unbuyableLootItemIds: []
    }
  },
  computed: Object.assign(mapState(['currentUser', 'currentGoldBalance', 'currentBalance', 'lootShopLootItemIds', 'lootShopLootItems', 'myOwnedLootItemIds', 'ownedLootItems']), {
  }),
  methods: {
    async refreshLootItems () {
      this.$store.dispatch('fetchLootShopLootItems')
      this.$store.dispatch('fetchOwnedLootItems')
    },
    categoryTextFor (shopItem) {
      if (shopItem.category === 'lootChest') {
        return 'Virtual LOOTCHEST'
      } else if (shopItem.category === 'roomItem') {
        return 'Virtual Room Item'
      } else {
        return 'Token'
      }
    },
    lootShopLootItemForId (id) {
      return this.$store.state.lootShopLootItems[id]
    },
    lootItemImageUrl (lootItem) {
      return `${Vue.config.WEB_ASSET_BASE_URL}/${lootItem.image_url}`
    },
    currencyIcon (priceCurrencyType) {
      let image = priceCurrencyType === 'mt' ? 'swiftGold.png' : 'swiftBucks.png'

      return `${Vue.config.WEB_ASSET_BASE_URL}/${image}`
    },
    attributionText (lootItem) {
      if (!lootItem.attribution_author) { return }
      // // "Creative Commons 10th Birthday Celebration San Francisco" by tvol is licensed under CC BY 2.0
      return `<a href="${lootItem.attribution_title_url}" target="_blank">"${lootItem.attribution_title}"</a> by <a href="${lootItem.attribution_author_url}" target="_blank">${lootItem.attribution_author}</a> <br/> Licensed under <a href="${lootItem.attribution_license_url}" target="_blank">${lootItem.attribution_license}</a>`
    },
    requiresAttribution (lootItem) {
      return !!lootItem.attribution_author
    },
    allowedToBuy (lootItem) {
      if (this.ownedLootItemsByLootItemId && this.ownedLootItemsByLootItemId[lootItem.id]) {
        if (lootItem.max_allowed > 0 && lootItem.max_allowed <= this.ownedLootItemsByLootItemId[lootItem.id].quantity) {
          return {allowed: false, reason: 'Max already owned.'}
        }
      }

      if (this.unbuyableLootItemIds.indexOf(lootItem.id) !== -1) {
        return {allowed: false, reason: 'Purchased max number today, wait until tomorrow!'}
      }

      let price = new BigNumber(lootItem.price)
      let rightBalance = lootItem.price_currency_type === 'mt' ? this.currentGoldBalance : this.currentBalance
      let currentTotal = new BigNumber(rightBalance ? rightBalance.total : 0)
      if (price.gt(currentTotal)) {
        let message = lootItem.price_currency_type === 'mt' ? 'SwiftGOLD' : 'SwiftBUCKS'
        return {allowed: false, reason: `Not enough ${message}`}
      }

      return {allowed: true}
    },
    async buy (lootItem) {
      if (this.waitingForPurchase) {
        // this.notify("")
        return
      }

      this.waitingForPurchase = true
      let response
      try {
        response = await axios.post(`${Vue.config.CURRENCY_SERVICE_BASE_URL}/item_purchases`, {
          'lootItemId': lootItem.id.toString()
        }, {withCredentials: true})
      } catch (e) {
        if (e && e.response) {
          response = e.response
        }
      }

      if (response && response.data && response.data.success) {
        // this.$gtag.purchase({
        //   'affiliation': 'Loot Shop Page',
        //   'value': lootItem.price,
        //   'currency': lootItem.price_currency_type,
        //   'items': [
        //     {
        //       'id': lootItem.id,
        //       'name': lootItem.name
        //     }
        //   ]
        // })

        // this.$gtag.event('spend_virtual_currency', {
        // })

        this.$gtag.query('event', 'spend_virtual_currency', {
          item_name: lootItem.name,
          virtual_currency_name: lootItem.price_currency_type,
          value: parseInt(lootItem.price)
        })

        this.notify(`${lootItem.name} Purchased!`)
      } else if (response && response.data && response.data.error && response.data.error.error_code === 'ipmpd1') {
        this.notify(`Sorry! You've purchased the max number of ${lootItem.name} today, wait until tomorrow!`)
        this.unbuyableLootItemIds.push(lootItem.id)
      } else {
        this.notify('Error Purchasing - Try again later.')
      }

      setTimeout(() => {
        this.waitingForPurchase = false
      }, 1000)
      this.$store.dispatch('fetchBalances')
      this.$store.dispatch('fetchOwnedLootItems')
    },
    notify (text) {
      this.notification = text
      setTimeout(() => {
        this.notification = undefined
      }, 5000)
    }
  },
  watch: {
    ownedLootItems: {
      deep: true,
      handler: async function (nv, ov) {
        await Vue.nextTick()

        if (!this.ownedLootItems) { return }

        this.myOwnedLootItemIds.forEach(oliid => {
          Vue.set(this.ownedLootItemsByLootItemId, this.ownedLootItems[oliid].loot_item_id, this.ownedLootItems[oliid])
        })
      }
    },
    async currentUser () {
      await Vue.nextTick()
      this.$store.dispatch('fetchOwnedLootItems')
    }
  }
}
</script>

<style scoped>
  .rarity-common {
    color: rgb(255, 255, 255);
  }

  .rarity-uncommon {
    color: rgb(17, 116, 14);
  }

  .rarity-rare {
    color: rgb(51, 81, 212);
  }

  .rarity-legendary {
    color: rgb(190, 34, 204);
  }

  .rarity-exotic {
    color: rgb(228, 197, 21);
  }
  .shop-image {
    max-width: 200px;
    max-height:200px;
  }

  .shop-item {
    width: 200px;
  }

  .currency-icon {
    max-width:20px;
    padding-left: 5px;
  }

  .price-content {
    display: flex; 
    align-items: center;  
    justify-content: center;
  }

  .btn-enabled{
    width:100%;
    display: inline-block;
    border-top: 4px #b62626 solid;
    padding: 5px;
    border-radius: 4px;
    box-shadow: 0px 3px 3px 3px rgba(0, 0, 0, 0.4);
    transition: background-color 0.2s , border-color 0.2s;
    margin: 5px;
    min-width: 50px;
    user-select: none;
    color:white;

    background-color: #5A3E85;
    height: 40px;
    margin-top: 5px;
    border-radius: 5px;
    border-top: 2px rgb(126, 85, 187) solid;
    padding: 0px 10px;
    cursor: pointer;
    transition: background-color 0.3s;
}

.btn-enabled:hover{
    background-color: #b62626;
    border-top: 4px rgb(255, 0, 0) solid;
}
.btn-selected{
  background-color: #b62626;
    border-top: 4px rgb(255, 0, 0) solid;
}

</style><style>
a {
  text-decoration: none;
  color: #445278;
}

a:visited {
  color: #4d566e;
}

a:hover {
  color: #62729c;
}

</style>


// WEBPACK FOOTER //
// src/components/Loot-Shop.vue